module.exports = __webpack_public_path__ + "img/syzn2.7c67a8c4.png";